import {
  MyApprovalRequestsTableFieldsFragment,
  Maybe,
  ApprovalRequestStatus,
} from '../../../__generated__/graphql';

export type ApprovalRequestTableItem = {
  id: string;
  name: string;
  employee: {
    id: string;
    name: string;
    avatarUrl: Maybe<string>;
  };
  approvalStatus: ApprovalRequestStatus;
  actionDatetime: Maybe<string>;
  relatedRecordId: string;
  relatedRecordApiName: string;
  relatedRecordName: string;
  relatedRecordObjectName: string;
  createdDate: string;
  approverComment: Maybe<string>;
  actions: string;
};

export const mapApprovalRequests = (
  src: ReadonlyArray<MyApprovalRequestsTableFieldsFragment>,
): ApprovalRequestTableItem[] => {
  return src.map((item) => ({
    id: item.Id,
    name: item.Name,
    employee: {
      id: item.recordEmployee?.Id ?? '',
      name: item.recordEmployee?.Name ?? '',
      avatarUrl: item.recordEmployee?.avatar?.url ?? null,
    },
    approvalStatus: item.flair__Approval_Status__c,
    actionDatetime: item.flair__Action_Datetime__c,
    relatedRecordId: item.flair__Related_Id__c,
    relatedRecordApiName: item.flair__Related_Object_Name__c,
    relatedRecordName: item.relatedRecordName ?? '',
    relatedRecordObjectName: item.relatedRecordObjectName,
    createdDate: item.CreatedDate,
    approverComment: item.flair__Approver_Comment__c,
    actions: '',
  }));
};
